import { container } from '@graphistry/falcor-react-redux';
import { createLogger } from '@graphistry/common/logger';
const logger = createLogger(__filename);

const User = container({
    renderLoading: false,
    fragment: (fetched = {}) => {
        logger.debug({fetched}, 'User1::fragment');
        //console.debug({fetched}, 'User2::fragment');
        return `{
            id,
            name, username, graphistryHost, email, userId,
            sesionid, csrfToken,
            csrfmiddlewaretoken, isAuthenticated, isStaff, isSuperUser,
            flags: { flag_share_modal },
            entitlements: {
                individual: { is_active, is_exist },
                team: { is_active, is_exist },
                enterprise: { is_active, is_exist },
                GRAPHISTRY_CLOUD
            }
        }`;
    }
})(() => null); // non-visual

export { User };
